<div>
  <router-outlet></router-outlet>
  <shared-toast-viewport />
</div>
